import { z } from 'zod';

import locales from 'common/zod/locales';
import { nonEmptyStringSchema } from 'common/zod/schemas';

import formLocales from './locales';

const MIN_VALUE = 0.01;
const MAX_VALUE = 5000;

export const setupBudgetCardFormSchema = z.object({
  amount: z
    .number({
      invalid_type_error: locales.errors.required,
      required_error: locales.errors.required,
    })
    .min(
      MIN_VALUE,
      formLocales.formatString(formLocales.fields.amount.errors.min, {
        min: MIN_VALUE,
      }),
    )
    .max(
      MAX_VALUE,
      formLocales.formatString(formLocales.fields.amount.errors.max, {
        max: MAX_VALUE,
      }),
    ),
  description: nonEmptyStringSchema,
});

export type SetupBudgetCardFormValues = z.infer<
  typeof setupBudgetCardFormSchema
>;
